// import { handleAnchorJump } from "./anchor-jump.js";
import { setupAnimations } from './animations.js';
import { setupStickyHeader } from './header.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Flip } from "gsap/Flip";


gsap.registerPlugin(Flip);

gsap.registerPlugin(ScrollTrigger);

window.animations = {
  gsap: gsap,
  ScrollTrigger: ScrollTrigger,
  Flip: Flip,
};

/**
 * Custom DOM ready function
 */
function onDomReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}

/**
 * Application entrypoint
 */
onDomReady(() => {
  setupStickyHeader();
  // Verhindere Laden im Editor
  if (!document.body.classList.contains("is-admin")) {
    setupAnimations(gsap, ScrollTrigger);
  }
  // setupBlockInteraction();

  // jQuery ready
  // TODO: jquery needed?
  // $(function () {
  //   handleAnchorJump();
  // });
});
